<style lang="less" src="./news.less" scoped></style>
<template>
  <div class="notice-main" v-show="isShow" @click="goTo">
    <img :src="notice_img" class="notice-img" />
    <div class="text">
      <!-- <ul id="listUL" class="tran">
        <li v-for="(item, index) in newsListR" :key="index">{{ item }}</li>
      </ul> -->
      <div class="scroll-up" ref="scroll">
        <ul id="listUL" class="tran">
          <li v-for="(item, index) in newsListR" :key="index">{{ item }}</li>
        </ul>
        <!-- <ul>
          <li v-for="item in scrollData" :key="item.id">
            {{ item.title }}
          </li>
        </ul> -->
      </div>
    </div>
    <span class="num" v-show="newsLists.length >= 2">
      共{{ newsLists.length }}条
    </span>
    <img :src="arrow_right" class="arrow-right" />
  </div>
</template>
<script>
import notice_img from "@img/common/notice.png";
import arrow_right from "@img/common/arrow_right .png";
import { newsList } from "@src/service/news/news.js";
export default {
  data() {
    return {
      scrollData: [
        { id: 1, title: "架不住公司高层喜欢这种玩意儿" },
        { id: 2, title: "用在vue项目中的需求跟原生js的实现方法" },
        { id: 3, title: "文字间歇无缝向上滚动" },
        { id: 4, title: "即使你有一百个不乐意，谁让是人家给你发工资呢" },
        { id: 5, title: "今天就单拎出来一种实现方法" }
      ],
      scrollArea: "",
      speed: 20,
      timer: null,
      delay: 6000,
      liHeight: "",
      isShow: false,
      newsLists: [],
      total: 0,
      newsListR: [],
      notice_img,
      arrow_right,
      timer: "",
      activityIndex: 0
    };
  },
  async mounted() {
    const that = this;
    const _obj = {
      pageNum: 1,
      pageSize: 2
    };
    const _res = await newsList(_obj);
    _res && that.$emit("isShow", true);
    _res &&
      (function() {
        that.newsLists = _res.data.list;
        that.isShow = true;
        that.rollFiflter(_res.data.list);
        that.total = _res.data.page.total;
        that.$nextTick(() => {
          that.scrollArea = that.$refs.scroll;
          let li = that.scrollArea.getElementsByTagName("li");
          that.liHeight = li[0].offsetHeight;
          that.scrollArea.scrollTop = 0;
          that.scrollArea.innerHTML += that.scrollArea.innerHTML;
          setTimeout(that.startScroll, that.delay);
        });
      })();
  },
  methods: {
    startScroll() {
      this.timer = setInterval(this.scrollUp, this.speed);
      this.scrollArea.scrollTop++;
    },
    scrollUp() {
      if (this.scrollArea.scrollTop % this.liHeight == 0) {
        clearInterval(this.timer);
        setTimeout(this.startScroll, this.delay);
      } else {
        this.scrollArea.scrollTop++;
        if (this.scrollArea.scrollTop >= this.scrollArea.scrollHeight / 2) {
          this.scrollArea.scrollTop = 0;
        }
      }
    },
    rollFiflter(data) {
      const that = this;
      let _fiflterArr = [];
      function silceFun(datas) {
        const _arr = [];
        if (datas.length > 18) {
          const _silce1 = datas.substring(0, 18);
          const _silce2 = datas.substring(18, datas.length);
          _arr.push(_silce1);
          _arr.push(_silce2);
        } else {
          _arr.push(datas);
        }
        return _arr;
      }
      if (data.length > 0) {
        const _length = data.length;
        switch (_length) {
          case 1:
            const _controlName = data[0].controlName;
            const _arr1 = silceFun(_controlName);
            _fiflterArr = _arr1;
            break;
          case 2:
            const _arr21 = silceFun(data[0].controlName);
            _fiflterArr = _arr21;
            const _arr22 = silceFun(data[1].controlName);
            _fiflterArr = [..._fiflterArr, ..._arr22];
          default:
            break;
        }
      }
      that.newsListR = _fiflterArr;
    },
    goTo() {
      const that = this;
      that.$router.push({
        name: "notices"
      });
    },
    /**
     * feat:公告滚动定时器
     */
    roll() {
      const that = this;
      const listUL = document.getElementById("listUL");
      const listLength = listUL.children.length;
      listUL.classList.add("tran");
      if (that.activityIndex < listLength - 1) {
        that.activityIndex++;
      } else {
        listUL.classList.remove("tran");
        that.activityIndex = 0;
      }
      listUL.style.marginTop = -that.activityIndex * 25 + "px";
    }
  },
  watch: {
    newsListR: {
      handler(newValue) {
        if (newValue.length <= 1) {
          this.$emit("clearTime");
        }
      },
      deep: true
    }
  }
};
</script>
